export default __webpack_public_path__ + "static/characters02-8bb8794875bee30d1527edcb926c9384.png";